import getConfig from 'next/config';

import React from 'react';
import { connect } from 'react-redux';
import { Header } from '@binanceus/layout';
import { ThemeProvider, lightTheme } from '@binanceus/uikit-theme';

import PropTypes from 'prop-types';

import { createCookie, eraseCookie } from '../../utils/cookies-browser';
import { setPublicAssetsStatus } from '../../actions/actionsSet/userConfig';
import withI18n from '../../utils/withI18n';
import { getUserBtcValuation as getUserBtcValuationAction } from '../../actions/actionsSet/assetService';
import { setNativeCurrency } from '../../actions/load';
import { updateUserConfigRequest as updateUserConfig } from '../../actions/actionsSet/account';
import { setItem, getItem } from '../../utils/localStorage';
import { track, sensorEventTypes } from '../../utils/sensors';
import { Logout } from '../../actions/actionsSet/authcenter';

const {
  publicRuntimeConfig: {
    inmailWssUrl,
    albHost,
  },
} = getConfig();

const mapStateToProps = ({
  isLoggedIn,
  userInfo,
  selectedPair,
  userPreferredCurrency,
  allUserAssetsBTCValues,
  currencyList,
  shouldPublicAssets,
}) => ({
  isLoggedIn,
  userInfo,
  selectedPair,
  userPreferredCurrency,
  allUserAssetsBTCValues,
  currencyList,
  shouldPublicAssets,
});

const mapDispatchToProps = {
  getUserBtcValuation: getUserBtcValuationAction,
  setNativeCurrency,
  Logout,
  setPublicAssetsStatus,
};

let CHAT_SHOW_FLAG = true;

@withI18n
@connect(mapStateToProps, mapDispatchToProps)
class HeaderWrapper extends React.PureComponent {
  static propTypes = {
    isLoggedIn: PropTypes.bool,
    i18n: PropTypes.object,
    locale: PropTypes.string.isRequired,
    userInfo: PropTypes.object,
    selectedPair: PropTypes.string,
    getUserBtcValuation: PropTypes.func,
    allUserAssetsBTCValues: PropTypes.object,
    currencyList: PropTypes.array,
    setNativeCurrency: PropTypes.func,
    userPreferredCurrency: PropTypes.object,
    Logout: PropTypes.func,
    setPublicAssetsStatus: PropTypes.func,
    shouldPublicAssets: PropTypes.bool,
    showScaleAnimation: PropTypes.bool,
    withClientApiCache: PropTypes.bool,
  };

  componentDidMount() {
    const { getUserBtcValuation, isLoggedIn, withClientApiCache, locale } = this.props;

    isLoggedIn && getUserBtcValuation(withClientApiCache);
  }

  componentDidUpdate(prevProps) {
    const { isLoggedIn, withClientApiCache } = this.props;
    if (!prevProps.isLoggedIn && isLoggedIn) {
      this.props.getUserBtcValuation(withClientApiCache);
    }

    if (CHAT_SHOW_FLAG) {
      // set chat user data
      const timer = setInterval(() => {
        this._setLocalStorage(timer);
      }, 1000);
    }
    if (typeof window !== 'undefined') {
      if (window.setChatLang) {
        window.setChatLang(this.props.locale);
      } else {
        const timer = setInterval(() => {
          if (window.setChatLang) {
            clearInterval(timer);
            window.setChatLang(this.props.locale);
          }
        }, 100);
      }
    }
  }

  _setLocalStorage = timer => {
    // set chat user data
    const { userInfo } = this.props;
    if (userInfo && userInfo.email) {
      const chatUserData = {
        email: userInfo.email,
        id: userInfo.userId,
        level: userInfo.tradeLevel,
      };
      if (window.setChatUserInfo) {
        window.setChatUserInfo(chatUserData);
      }
      if (timer) clearInterval(timer);
      CHAT_SHOW_FLAG = false;
    } else if (timer) clearInterval(timer);
  };

  _getUserData = () => {
    const { isLoggedIn, userInfo } = this.props;

    if (!isLoggedIn) return {};

    return userInfo;
  };

  _getCurrency = () => {
    const { userPreferredCurrency } = this.props;
    let pair;

    if (userPreferredCurrency && userPreferredCurrency.configName) {
      pair = userPreferredCurrency.configName;
    } else if (typeof window !== 'undefined') {
      pair = getItem(window.localStorage, 'userPreferredCurrency');
    }
    return pair;
  };

  _setNativeCurrency = currency => {
    const { locale } = this.props;
    const config = {
      configName: currency.pair,
      configType: 'nativeCurrency',
    };

    track(sensorEventTypes.SWITCH_FIAT_RATE, {
      fiatCurrency: currency.pair,
    });
    this.props.setNativeCurrency(config);
    if (this.props.isLoggedIn) {
      try {
        updateUserConfig(config, locale);
      } catch (e) {
        // donothing
      }
    }
    setItem(window.localStorage, 'userPreferredCurrency', config.configName);
  };

  _handleShowAsset = status => {
    createCookie('shouldPublicAssets', status);
    this.props.setPublicAssetsStatus(status);
  };

  _onLegacyClick = () => {
    const { locale } = this.props;

    eraseCookie('canary');
    createCookie('canary', 'legacy', 1, false);
    window.location.href = `/${locale}?canary=legacy`;
  };

  _handleLogout = () => {
    const { locale } = this.props;

    this.props.Logout(null, locale);
  };

  _getCurrenciList = () => {
    const { currencyList } = this.props;

    return currencyList.filter(item => item.name !== 'USD');
  };

  render() {
    const {
      userInfo,
      isLoggedIn,
    } = this.props;

    return (
      <ThemeProvider theme={lightTheme}>
        <Header
          fixed={true}
          inmailWssUrl={inmailWssUrl}
          account={{ isLoggedIn, accountInfo: userInfo }}
        />
      </ThemeProvider>

    );
  }
}

export default HeaderWrapper;
